﻿<template>
    <div class="custom-table-component">
        <div class="header-table-content">
            <div class="top-header-content">

                <div class="left-content" v-show="!mobile || (mobile && open)">

                    <div class="complex-search-content" v-if="searchComponent">
                        <div class="complex-search">
                            <el-select v-model="currentColumnSearch" class="complex-select" placeholder="coluna"
                                size="small" @change="columnSearchChange">

                                <el-option v-for="item in complexSearchColumns" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>

                            </el-select>

                            <span class="complex-pipe"></span>

                            <el-input v-model="search" placeholder="Pesquisar" @input="delaySearchInput"
                                @clear="complexSearchExec" clearable />
                        </div>
                        <div class="complex-tags-hidder">
                            <div class="complex-tags-content">

                                <div class="complex-tag" v-for="(item, index) in searchTags" :key="index">

                                    <div class="tag-main-content">

                                        <span class="tag-col">
                                            {{defaultTableHeader.find(x => x.value == item.column).name}}
                                        </span>

                                        <span class="tag-search">{{ item.value }}</span>

                                    </div>

                                    <button type="button" class="complex-close-tag" @click="removeComplexTag(index)">
                                        <el-icon>
                                            <close-bold />
                                        </el-icon>
                                    </button>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="right-content">
                    <!-- <button type="button" @click="openFilters">click</button>          
                    <el-button class="filter-button" type="primary" @click="openFilters">
                    Teste
                        <el-icon :size="50">
                            <operation />
                        </el-icon>
                    </el-button> -->

                    <slot name="header-add-buttons">
                        <el-button v-if="customForm && (!readDataOnly || (!readDataOnly && enableInsert))"
                            type="primary" @click="newData">
                            Novo Registro
                        </el-button>

                        <el-button v-if="!customForm && (!readDataOnly || (!readDataOnly && enableInsert))"
                            type="primary" @click="openModal">
                            Novo Registro
                        </el-button>
                    </slot>

                    <el-button class="export-btn excel-btn" v-if="exportExcel" @click="exportExcelMethod">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 48 48" width="50px"
                            height="50px">
                            <path
                                d="M 23.576172 4.0664062 C 23.314218 4.0591207 23.047263 4.0824054 22.779297 4.1386719 L 8.5722656 7.1308594 C 6.4998481 7.5683366 5 9.4137099 5 11.533203 L 5 36.466797 C 5 38.585784 6.4983909 40.43285 8.5722656 40.869141 L 22.779297 43.859375 C 24.923297 44.311288 27 42.626019 27 40.435547 L 27 7.5644531 C 27 5.6477898 25.409849 4.117405 23.576172 4.0664062 z M 30 8 L 30 9.5 L 30 11 L 30 38 L 30 39.5 L 30 41 L 38.5 41 C 40.967501 41 43 38.967501 43 36.5 L 43 12.5 C 43 10.032499 40.967501 8 38.5 8 L 30 8 z M 34.5 15 L 37.5 15 C 38.328 15 39 15.671 39 16.5 C 39 17.329 38.328 18 37.5 18 L 34.5 18 C 33.672 18 33 17.329 33 16.5 C 33 15.671 33.672 15 34.5 15 z M 12.537109 16.998047 C 13.02002 17.010742 13.488281 17.251953 13.769531 17.689453 L 16 21.210938 L 18.230469 17.689453 C 18.680469 16.989453 19.610547 16.790469 20.310547 17.230469 C 21.000547 17.680469 21.209531 18.610547 20.769531 19.310547 L 17.779297 24 L 20.769531 28.689453 C 21.209531 29.389453 21.000547 30.319531 20.310547 30.769531 C 20.060547 30.919531 19.78 31 19.5 31 C 19.01 31 18.520469 30.750547 18.230469 30.310547 L 16 26.789062 L 13.769531 30.310547 C 13.479531 30.750547 12.99 31 12.5 31 C 12.22 31 11.939453 30.919531 11.689453 30.769531 C 10.999453 30.319531 10.790469 29.389453 11.230469 28.689453 L 14.220703 24 L 11.230469 19.310547 C 10.790469 18.610547 10.999453 17.680469 11.689453 17.230469 C 11.951953 17.065469 12.247363 16.99043 12.537109 16.998047 z M 34.5 23 L 37.5 23 C 38.328 23 39 23.671 39 24.5 C 39 25.329 38.328 26 37.5 26 L 34.5 26 C 33.672 26 33 25.329 33 24.5 C 33 23.671 33.672 23 34.5 23 z M 34.5 31 L 37.5 31 C 38.328 31 39 31.671 39 32.5 C 39 33.329 38.328 34 37.5 34 L 34.5 34 C 33.672 34 33 33.329 33 32.5 C 33 31.671 33.672 31 34.5 31 z">
                            </path>
                        </svg>
                    </el-button>

                    <el-button class="export-btn pdf-btn" v-if="exportPdf" @click="exportPDFMethod">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                            width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                            <g transform="translate(128 128) scale(0.72 0.72)" style="">
                                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                                    transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
                                    <path
                                        d="M 43.476 51.115 c -0.506 1.171 -1.041 2.343 -1.598 3.505 c 1.265 -0.341 2.54 -0.647 3.811 -0.915 c -0.328 -0.369 -0.652 -0.745 -0.971 -1.13 C 44.289 52.098 43.875 51.611 43.476 51.115 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path
                                        d="M 43.721 34.034 c -0.022 -2.083 -0.544 -2.348 -0.921 -2.382 c -0.482 0.098 -0.993 0.363 -1.327 1.283 c -0.638 1.754 -0.279 4.726 1.082 8.072 C 43.308 38.389 43.742 35.995 43.721 34.034 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path
                                        d="M 25.174 70.925 c 1.496 -0.417 4.109 -3.502 6.911 -7.831 c -2.218 1.18 -4.078 2.48 -5.367 3.865 C 25.079 68.718 24.947 70.009 25.174 70.925 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path
                                        d="M 63.203 57.569 c -1.763 -0.665 -4.363 -0.895 -7.39 -0.757 c 3.991 2.676 7.348 3.506 8.729 3.003 c 0.212 -0.078 0.366 -0.134 0.365 -0.708 C 64.897 58.837 64.832 58.184 63.203 57.569 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path
                                        d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 66.059 63.97 c -3.994 1.461 -10.583 -1.267 -16.537 -6.464 c -3.472 0.583 -7.118 1.492 -10.512 2.651 c -3.918 7.018 -8.338 12.876 -11.605 14.562 c -0.868 0.448 -1.73 0.67 -2.542 0.67 c -1.21 0 -2.307 -0.491 -3.143 -1.455 l -0.206 -0.238 l -0.132 -0.286 c -1.434 -3.113 -0.689 -6.475 2.098 -9.467 c 2.746 -2.948 7.3 -5.486 12.475 -7.428 c 1.674 -3.112 3.263 -6.441 4.561 -9.671 c -3.296 -5.596 -4.633 -11.492 -3.202 -15.423 c 0.857 -2.355 2.64 -3.839 5.021 -4.177 l 0.311 -0.022 c 2.651 0 4.554 1.572 5.219 4.311 c 0.808 3.33 -0.314 8.791 -2.465 14.744 c 0.78 1.151 1.67 2.299 2.667 3.409 c 0.952 1.148 1.915 2.189 2.872 3.127 c 5.583 -0.715 10.648 -0.582 13.825 0.617 c 3.876 1.463 4.524 4.121 4.565 5.575 l 0.001 0.044 C 69.35 61.41 68.157 63.203 66.059 63.97 z M 62.35 17.733 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 l 12.611 12.612 H 62.35 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                </g>
                            </g>
                        </svg>
                    </el-button>
                </div>

            </div>

            <div class="bottom-header-content" v-show="!mobile || (mobile && open)">
                <div class="date-range" v-if="filterDate">
                    <el-date-picker v-model="startDate" type="date" placeholder="Data Início" format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD" @change="searchInput" :clearable="true"
                        :disabled-date="maxDate"></el-date-picker>

                    <span>à</span>

                    <el-date-picker v-model="finishDate" type="date" placeholder="Data Fim" format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD" @change="searchInput" :clearable="true"
                        :disabled-date="minDate"></el-date-picker>
                </div>

                <slot name="filters"></slot>

                <el-button v-if="!autoSearch" type="primary" @click="searchInput">
                    Buscar
                </el-button>

                <el-button v-if="!autoSearch" type="info" plain @click="clearFilters">
                    Limpar
                </el-button>
            </div>
        </div>

        <div id="customTable-totalizer"></div>

        <div class="custom_table_content">
            <el-table :id="tableId" :data="localTableData" ref="tableEl" style="width: 100%; min-height: 250px" stripe
                :empty-text="dataTableEmptyText" height="250px">

                <el-table-column type="expand" v-if="localTableHeaderExpand.length > 0">
                    <template #default="props">
                        <div class="expanded_content">
                            <div class="expand-item" v-for="(item, index) in localTableHeaderExpand" :key="index">
                                <strong>{{ item.name }}: </strong>
                                <slot :name="'col-' + item.value" :item="props.row">
                                    {{ getColumnValue(item.value, props.row) }}
                                </slot>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column v-for="(item, index) in localTableHeader" :key="index" :label="item.name"
                    :prop="item.value" :min-width="item.width ?? 'auto'" :width="item.value == 'actions' ? 75 : 'auto'">

                    <template #header>
                        <div :class="sortBy == item.value ? 'custom_sort_header' : ''" @click="sort(item)">
                            {{ item.name }}
                            <div class="custom_sort_icon" v-if="sortBy == item.value">
                                <el-icon :size="10" v-if="sortDir">
                                    <ArrowDownBold />
                                </el-icon>
                                <el-icon :size="10" v-else>
                                    <arrow-up-bold />
                                </el-icon>
                            </div>
                        </div>
                    </template>

                    <template #default="props">
                        <div :class="isActiveClass(props.row)">
                            <div v-if="item.editableContent" class="editable-tr"
                                @keyup.enter="submitEditRow(props.row, item.value)">
                                <div v-if="!editableRowsControl[item.value + '-' + props.row.id]" class="editable-label"
                                    @click.prevent="toggleEditRow(props.row, item.value)">
                                    <slot :name="'col-' + item.value" :item="props.row" v-if="item.value != 'actions'">
                                        <el-tooltip :content="getColumnValue(item.value, props.row)"
                                            v-if="getColumnValue(item.value, props.row)?.length > 30" placement="top">
                                            <span>
                                                {{ getColumnValue(item.value, props.row) }}
                                            </span>
                                        </el-tooltip>

                                        <span v-else>
                                            {{ getColumnValue(item.value, props.row) }}
                                        </span>
                                    </slot>
                                </div>
                                <slot :name="'editable-col-' + item.value" :item="props.row" v-else>
                                    <el-input v-model="props.row[item.value]" style="text-align: center;"
                                        @blur.prevent="submitEditRow(props.row, item.value)"></el-input>
                                </slot>
                            </div>
                            <div v-else>
                                <slot :name="'col-' + item.value" :item="props.row" v-if="item.value != 'actions'">
                                    <el-tooltip :content="getColumnValue(item.value, props.row)"
                                        v-if="getColumnValue(item.value, props.row)?.length > 30" placement="top">
                                        <span>
                                            {{ getColumnValue(item.value, props.row) }}
                                        </span>
                                    </el-tooltip>

                                    <span v-else>
                                        {{ getColumnValue(item.value, props.row) }}
                                    </span>
                                </slot>
                            </div>
                        </div>

                        <el-dropdown trigger="click" v-if="item.value == 'actions'" class="action-btn">
                            <span class="el-dropdown-link">
                                <el-icon>
                                    <grid />
                                </el-icon><el-icon class="el-icon--right"><arrow-down /></el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <label>AÇÕES</label>

                                    <el-dropdown-item @click="editRow(props.row)" v-if="enableUpdate">
                                        <el-icon>
                                            <edit></edit>
                                        </el-icon>
                                        Editar
                                    </el-dropdown-item>

                                    <el-dropdown-item @click="deleteRow(props.row)" v-if="enableDelete">
                                        <el-icon>
                                            <close-bold />
                                        </el-icon>
                                        Excluir
                                    </el-dropdown-item>

                                    <slot name="action-button" :item="createInstance(props.row)">
                                    </slot>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <div class="bottom-table-content" v-if="pagination">
            <el-pagination v-model:current-page="localPage" @current-change="searchInput" :page-size="localPageSize"
                layout="prev, pager, next" :total="localTotalCount" background>
            </el-pagination>

            <select class="form-select form-select-sm form-select-solid" @change="searchInput" v-model="localPageSize">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
            </select>
        </div>

    </div>

    <!--MODAL DO FORMULÁRIO-->
    <div class="form-modal-ct" :id="RandomModalId">
        <el-dialog v-model="formVisibility" :close-on-click-modal="false"
            :close-on-press-escape="false" :title="tableName" @open="onDialogOpen" @close="clearForm(ruleFormRef)">

            <template #default>
                <!--formulario modal-->
                <el-form ref="ruleFormRef" :rules="rules" :model="ruleForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true"
                            data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                            data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                            data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">

                            <slot name="form-content">
                                <!-- TEMPLATES DO COMPONENTE FORMULÁRIO -->
                            </slot>

                        </div>
                    </div>
                </el-form>
            </template>

            <template #footer>
                <span class="dialog-footer">
                    <el-button type="info" id="modal_form_cancel" data-bs-dismiss="modal" aria-label="Close"
                        @click="closeModal" plain>
                        {{ cancelButtonText }}
                    </el-button>

                    <el-button :disabled="enableButton" type="success" @click="submit(ruleFormRef)">
                        {{ saveButtonText }} &nbsp; <el-icon>
                            <FolderOpened />
                        </el-icon>
                    </el-button>

                    <slot name="form-buttons">
                        <!-- TEMPLATES DOS BOTÕES PARA O FORMULÁRIO  -->
                    </slot>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts">
import { onMounted, onUnmounted, ref, nextTick, watch, computed } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ReportModel, Expression, Column, ReportTypes } from "@/components/custom-table/ReportModel";
import type { ElForm } from 'element-plus'

import { TableEvents } from "@/components/custom-table/LiteEvents";

import { Actions, ReportActions } from "@/store/enums/StoreEnums";
import tableFilter from "./tableFilter";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
    props: {
        readDataOnly: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        autoSearch: {
            type: Boolean,
            default: () => {
                return true
            }
        },

        filterDate: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        exportExcel: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        exportPdf: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        pagination: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        actions: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        method: {
            type: String,
            default: () => {
                return null
            }
        },

        totalCount: {
            type: Number,
            default: 0
        },

        tableHeader: {
            type: Array,
            default: () => {
                return []
            }
        },

        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },

        page: {
            type: Number,
            default: () => {
                return 1
            }
        },

        pageSize: {
            type: Number,
            default: () => {
                return 10
            }
        },

        tableName: {
            type: String,
            default: () => {
                return ''
            }
        },

        report: {
            type: ReportModel,
            default: () => {
                return null
            }
        },

        customForm: {
            type: Boolean,
            default: () => {
                return null
            }
        },

        customFilters: {
            type: Object,
            default: () => {
                return null
            }
        },

        rules: {
            type: Object,
            default: () => {
                return {}
            }
        },

        ruleForm: {
            type: Object,
            default: () => {
                return {}
            }
        },

        events: {
            type: TableEvents,
            default: () => {
                return null
            }
        },

        cancelButtonText: {
            type: String,
            default: () => {
                return 'Cancelar'
            }
        },

        saveButtonText: {
            type: String,
            default: () => {
                return 'Salvar'
            }
        },
        dataDefaultSort: {
            type: String,
            default: () => {
                return 'id'
            }
        },
        dataDefaultSortDirection: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        editButton: {
            type: Boolean,
            default: () => {
                return true
            }
        },

        deleteButton: {
            type: Boolean,
            default: () => {
                return true
            }
        },


        totalizers: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        tableClaim: {
            type: String,
            default: () => {
                return ''
            }
        },

        searchComponent: {
            type: Boolean,
            default: () => {
                return true
            }
        },
    },

    emits: ["search", "newData", "submit", "clean", "resolve", "closeForm", "editItem", "deleteItem", "toggleEditRow"],

    setup(props, { emit }) {
        // instancias formulario
        type formInstance = InstanceType<typeof ElForm>
        const ruleFormRef = ref<formInstance>();
        const formVisibility = ref(false);

        // config methods and variables
        const store = useStore();
        const typingTimer = ref(0);
        const RandomModalId = ref(Math.random().toString(36).replace(/[^a-z]+/g, ''));
        const AutoSearch = ref(props.autoSearch);

        // Altera tamanho para tela inteira
        store.dispatch(Actions.CHANGE_CONTAINER_TYPE, "fluid");

        // mobile expandable filters
        const mobile = ref(false);
        const open = ref(false);

        const openFilters = () => {
            open.value = !open.value;
        }

        // Table Header model
        type columnType = {
            name: string,
            value: string,
            width: number,
            canHide: boolean,
            sort: boolean,
            searchable: boolean,
            defaultFilter: boolean,
            defaultSort: boolean,
            defaultSortDirection: boolean,
            editableContent: boolean,
            reportColumnName: string,
            reportColumnType: ReportTypes,
        };

        // Table variables
        const localTableData = ref<any>(props.tableData);
        const defaultTableHeader = ref<any>(props.tableHeader);
        const complexSearchColumns = ref<any>(defaultTableHeader.value.filter(x => x.searchable));
        const enableButton = ref(false);

        watch(
            () => props.tableData,
            () => {
                if (!props.method)
                    localTableData.value = props.tableData;
            }, {
            deep: true
        }
        );


        class bollObject {
            [index: string]: Boolean;
        }

        const editableRowsControl = ref<bollObject>({});

        if (localTableData.value && localTableData.value.length > 0) {
            localTableData.value.filter(item => {
                defaultTableHeader.value.filter(prop => {
                    if (prop.editableContent)
                        editableRowsControl.value[`${prop.value}-${item.id}`] = false;
                });
            });
        }

        const localTableHeader = ref<columnType[]>([]);
        const localTableHeaderExpand = ref<columnType[]>([]);

        if (props.actions) {
            let model = {
                name: "",
                value: "actions",
                width: 150,
                canHide: false
            };

            localTableHeader.value.unshift(model as columnType);
        }

        // search component
        class tagModel {
            public column: string;
            public value: string;

            constructor() {
                this.column = '';
                this.value = '';
            }
        };

        const currentColumnSearch = ref(props.searchComponent ? (defaultTableHeader.value.some(x => x.defaultFilter) ? defaultTableHeader.value.find(x => x.defaultFilter).value : complexSearchColumns.value[0].value) : null);
        const searchData = ref<tagModel[]>([]);
        const searchTags = ref<tagModel[]>([]);
        const search = ref<string>('');

        // date component
        const startDate = ref<any>(null);
        const finishDate = ref<any>(null);

        const minDate = (time: Date) => {
            return time.getTime() < new Date(startDate.value ?? '').getTime();
        };

        const maxDate = (time: Date) => {
            return time.getTime() > new Date(finishDate.value ?? '').getTime();
        };

        // table filters
        const sortBy = ref(null);
        const sortDir = ref(true);
        const localPage = ref(props.page);
        const localPageSize = ref(props.pageSize);
        const localTotalCount = ref(props.totalCount);

        const newFilters = computed(() => { return props.customFilters });

        watch(
            () => newFilters,
            () => {
                if (AutoSearch.value)
                    searchInput();
            }, {
            deep: true
        });

        const tableReload = computed(() => { return store.getters.reloadCustomTable });

        watch(
            () => tableReload.value,
            () => {
                searchInput();
            }, {
            deep: true
        });

        // store table filters
        class storeTableFilters {
            get(tableName) {
                let values = window.localStorage.getItem(`${tableName.replace(/ /gi, '_')}-TableFilters`);
                if (values) {
                    let object = JSON.parse(values);

                    if (object.sortBy) sortBy.value = object.sortBy;
                    if (object.sortDir) sortDir.value = object.sortDir;
                    if (object.page) localPage.value = object.page;
                    if (object.pageSize) localPageSize.value = object.pageSize;
                    if (object.startDate) startDate.value = object.startDate;
                    if (object.finishDate) finishDate.value = object.finishDate;
                    // complex search
                    if (props.searchComponent && object.searchData) {
                        searchData.value = object.searchData;
                        searchTags.value = object.searchData.filter(item => item.value != currentColumnSearch.value);
                    }

                    if (object.newFilters) {
                        Object.keys(object.newFilters).map(item => {
                            if ((newFilters.value[item] == null || newFilters.value[item] == ``) && object.newFilters[item]) newFilters.value[item] = object.newFilters[item]
                        })
                    }
                }
            }

            clear(tableName) {
                window.localStorage.removeItem(`${tableName.replace(/ /gi, '_')}-TableFilters`);
            }

            set(tableName) {
                this.clear(tableName.replace(/ /gi, '_'));

                let filters: { [k: string]: any } = {};
                filters.sortBy = sortBy.value;
                filters.sortDir = sortDir.value;
                filters.page = localPage.value;
                filters.pageSize = localPageSize.value;
                filters.startDate = startDate.value;
                filters.finishDate = finishDate.value;
                filters.searchData = searchData.value;

                if (newFilters.value) {
                    filters.newFilters = newFilters.value
                }

                window.localStorage.setItem(`${tableName.replace(/ /gi, '_')}-TableFilters`, JSON.stringify(filters));
            }
        };

        const StoreFiltresData = new storeTableFilters();

        // Get table data
        const dataTableEmptyText = ref('Carregando...');
        const commandData = ref('');

        const getTableData = (data) => {
            try {
                store.dispatch(action.value, data).then((res) => {
                    if (res === undefined && res === null &&
                        res.values === undefined && res.values === null) {

                        res = {
                            values: {
                                results: []
                            }
                        };
                    }

                    if (res && res.values && res.values.results) {
                        // StoreFiltresData.set(TableName.value);
                        localTableData.value = res?.values?.results;
                        localTotalCount.value = res?.values?.rowCount;
                        commandData.value = res?.values?.commandData;

                        if (res?.values?.results.length <= 0)
                            dataTableEmptyText.value = 'Nenhum registro encontrado.';
                        else
                            dataTableEmptyText.value = 'Carregando...';

                        // seting header when is not defined
                        if (props.tableHeader.length <= 0) {
                            Promise.all(Object.keys(localTableData.value[0]).map((item, index) => {
                                defaultTableHeader.value.push({
                                    name: item,
                                    value: item,
                                    width: 150,
                                    canHide: index != 0 ? true : false,
                                    searchable: true
                                });
                            })).then(() => {
                                emit("resolve", res, data);
                            });
                        } else {
                            emit("resolve", res, data);
                        }

                        localTableData.value.filter(item => {
                            defaultTableHeader.value.filter(prop => {
                                if (prop.editableContent)
                                    editableRowsControl.value[`${prop.value}-${item.id}`] = false;
                            });
                        });
                    }
                    else { dataTableEmptyText.value = 'Nenhum registro encontrado.'; }
                });
            } catch (exception) {
                dataTableEmptyText.value = 'Nenhum registro encontrado.';
                console.error(exception);
            }
        };

        const action = ref(props.method);

        if (action.value) {
            StoreFiltresData.get(props.tableName);

            let data: { [k: string]: any } = {
                search: searchData.value,
                sortBy: sortBy.value,
                sortDir: sortDir.value,
            };

            // setting date filter in params
            if (props.filterDate) {
                data.startDate = startDate.value;
                data.endDate = finishDate.value;
            }

            // seting pagination to params
            if (props.pagination) {
                data.page = localPage.value;
                data.pageSize = localPageSize.value;
            }

            // default sort
            if (!data.sortBy || data.sortBy == '') {
                let defaultSort = defaultTableHeader.value.find(item => item.defaultSort == true);
                if (defaultSort) {
                    data.sortBy = defaultSort.value;
                    data.sortDir = defaultSort.defaultSortDirection;
                }
                else if (props.dataDefaultSort) {
                    data.sortBy = props.dataDefaultSort;
                    data.sortDir = props.dataDefaultSortDirection;
                }
            }

            let model = Object.assign(data, newFilters.value);

            StoreFiltresData.set(props.tableName);

            getTableData(model);
        }

        // Export functions
        const ReportProp = ref(props.report);
        const TableName = ref(props.tableName);

        const exportDispatch = (type, model) => {
            switch (type) {
                case 1:
                    store.dispatch(ReportActions.GET_REPORT_EXCEL, JSON.parse(model)).then(res => {
                        if (!res.values.fileURL) {
                            Swal.fire({
                                text: "Ocorreu um erro na geração do relatório, entre em contato com o Administrador do sistema.",
                                icon: "warning",
                                buttonsStyling: false,
                                confirmButtonText: "Ok",
                                customClass: {
                                    confirmButton: "btn btn-primary",
                                },
                            });
                        }
                        else {
                            let win = window.open(res.values.fileURL.Absolute ?? res.values.fileURL, '_blank');
                            if (win) {
                                win.focus();
                            } else {
                                Swal.fire({
                                    text: "Por favor, permita pop-ups para este site.",
                                    icon: "warning",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                        confirmButton: "btn btn-primary",
                                    },
                                });
                            }
                        }
                    });
                    break;
                case 2:
                    store.dispatch(ReportActions.GET_REPORT_PDF, JSON.parse(model)).then(res => {
                        let win = window.open(res.values.fileURL.Absolute ?? res.values.fileURL, '_blank');
                        if (win) {
                            win.focus();
                        } else {
                            Swal.fire({
                                text: "Por favor, permita pop-ups para este site.",
                                icon: "warning",
                                buttonsStyling: false,
                                confirmButtonText: "Ok",
                                customClass: {
                                    confirmButton: "btn btn-primary",
                                },
                            });
                        }
                    });
                    break;
                case 3:
                    store.dispatch(ReportActions.GET_REPORT_CSV, JSON.parse(model)).then(res => {
                        let win = window.open(res.values.fileURL.Absolute ?? res.values.fileURL, '_blank');
                        if (win) {
                            win.focus();
                        } else {
                            Swal.fire({
                                text: "Por favor, permita pop-ups para este site.",
                                icon: "warning",
                                buttonsStyling: false,
                                confirmButtonText: "Ok",
                                customClass: {
                                    confirmButton: "btn btn-primary",
                                },
                            });
                        }
                    });
                    break;
            }
        }

        const exportData = (type) => {

            let model = new ReportModel();

            if (TableName.value.length > 0)
                model.ReportName = TableName.value;

            if (ReportProp.value) {
                model = ReportProp.value;

                if (!ReportProp.value.commandData || ReportProp.value.commandData == '')
                    model.commandData = commandData.value;

                exportDispatch(type, JSON.stringify(model));
            } else {
                let expression = new Expression();
                expression.ExpressionType = 0;

                Promise.all(defaultTableHeader.value.map((item: any) => {
                    if (item.reportColumnName && item.reportColumnName.length > 0) {
                        let column = new Column();

                        //column.Name = item.reportColumnName;
                        column.Description = item.name;

                        if (item.reportColumnType == ReportTypes.boolean)
                            column.Value = `((${item.reportColumnName} ?? false) ? "Sim":"Não")`;
                        else if (item.reportColumnType == ReportTypes.date)
                            column.Value = `((${item.reportColumnName}.HasValue) ? ${item.reportColumnName}.Value.ToString("dd/MM/yyyy") : "-")`;
                        else if (item.reportColumnType == ReportTypes.dateTime)
                            column.Value = `((${item.reportColumnName}.HasValue) ? ${item.reportColumnName}.Value.ToString("dd/MM/yyyy HH:mm:ss") : "-")`;
                        else
                            column.Value = item.reportColumnName;

                        expression.Columns.push(column);
                    }
                })).then(() => {
                    model.Expressions.push(expression);
                    model.commandData = commandData.value;

                    exportDispatch(type, JSON.stringify(model));
                });
            }
        };

        // Custom table events
        const columnSearchChange = () => {
            searchTags.value = searchData.value.filter(item => item.column != currentColumnSearch.value);

            if (searchData.value.some(item => item.column == currentColumnSearch.value)) {
                let data = searchData.value.find(item => item.column == currentColumnSearch.value);
                search.value = data?.value ?? '';
            } else {
                if (searchData.value.length > 0)
                    search.value = '';
            }
        };

        const removeComplexTag = (index) => {
            searchTags.value.splice(index, 1);
            searchData.value.splice(index, 1);

            if (AutoSearch.value)
                searchInput();
        };

        const complexSearchExec = () => {

            if (searchData.value.some(item => item.column == currentColumnSearch.value)) {
                if (search.value.length > 0) {
                    searchData.value.find(item => item.column == currentColumnSearch.value)!.value = search.value;
                } else {
                    removeComplexTag(searchData.value.findIndex(item => item.column == currentColumnSearch.value));
                }
            } else {
                if (currentColumnSearch.value && search.value) {
                    let model: any = {
                        column: currentColumnSearch.value,
                        value: search.value
                    };

                    searchData.value.push(model);
                }
            }

            if (AutoSearch.value && searchData.value.length > 0)
                searchInput();
        };

        const delaySearchInput = () => {
            clearTimeout(typingTimer.value);
            typingTimer.value = setTimeout(() => {

                complexSearchExec();

            }, 1000);
        };

        const clearFilters = () => {
            emit('clean');
            StoreFiltresData.clear(TableName.value);
            searchData.value = [];
            search.value = "";
            sortBy.value = null;
            sortDir.value = true;
            localPage.value = 1;
            localPageSize.value = 5;
            startDate.value = null;
            finishDate.value = null;
            searchTags.value = [];

            searchInput();
        };

        const searchInput = () => {
            enableButton.value = false;

            let data: { [k: string]: any } = {
                search: searchData.value,
                sortBy: sortBy.value,
                sortDir: sortDir.value,
            };

            // setting date filter in params
            if (props.filterDate) {
                data.startDate = startDate.value;
                data.endDate = finishDate.value;
            }

            // seting pagination to params
            if (props.pagination) {
                data.page = localPage.value;
                data.pageSize = localPageSize.value;
            }

            // default sort
            if (!data.sortBy || data.sortBy == '') {
                let defaultSort: any = defaultTableHeader.value.find((item: any) => item.defaultSort == true);
                if (defaultSort) {
                    data.sortBy = defaultSort.value;
                    data.sortDir = defaultSort.defaultSortDirection;
                }
                else if (props.dataDefaultSort) {
                    data.sortBy = props.dataDefaultSort;
                    data.sortDir = props.dataDefaultSortDirection;
                }
            }

            let model = Object.assign(data, newFilters.value);

            StoreFiltresData.set(TableName.value);

            if (action.value) {
                getTableData(model);
            } else {
                emit('search', model);
            }
        };

        // excel export function here
        const exportExcelMethod = () => {
            exportData(1);
        };

        // PDF export function here
        const exportingPDF = ref(false);
        const exportPDFMethod = () => {
            exportingPDF.value = true;

            // expand table to see all results
            store.dispatch(Actions.SET_LOADING_TOGGLE, true);
            const tableContextID = tableEl?.value?.context?.tableId;

            let tableElement = document.querySelector(`#${tableContextID}`) as HTMLElement;

            // balões de texto
            let ballonTexts = document.querySelectorAll('.custom-note-buttom');
            if (ballonTexts) {
                ballonTexts.forEach(item => {
                    item.classList.add('export');
                })
            }

            let textDiv = document.querySelectorAll('.custom-note-text');
            if (textDiv) {
                textDiv.forEach(item => {
                    item.classList.add('export');
                })
            }

            if (tableElement) {
                const tableBodyHeight = (tableElement.querySelector('tbody')?.clientHeight ?? 0) + 50;
                tableElement.setAttribute("height", `${tableBodyHeight}`);
                tableElement.style.height = `${tableBodyHeight}px`;
            }

            setTimeout(() => {
                const element = document.getElementById("kt_wrapper");

                const pdf = new jsPDF('l', 'mm', 'a4', true);

                // setting font style
                pdf.setFont("courier");
                pdf.setFontSize(10);
                //pdf.setTextColor(255, 0, 0);

                // PDF page sizes
                const pageWidth = Number(pdf.internal.pageSize.getWidth());
                const pageHeight = Number(pdf.internal.pageSize.getHeight());

                // Image size
                const height = Number(element?.clientHeight) * pageWidth / Number(element?.clientWidth);
                let heightLeft = height;
                let position = 0;

                html2canvas(element as HTMLElement).then(canvas => {
                    const image = canvas.toDataURL('image/png');

                    // open image in new tab .:: FOR DEBUGG REASONS ::.
                    //let base64 = new Image();
                    //base64.src = image;
                    //let w = window.open("")?.document.write(base64.outerHTML);

                    //const today = new Date().toISOString().split('T')[0];

                    // inserting the image in pdf
                    pdf.addImage(image.toString(), 'PNG', 0, 0, pageWidth, height);

                    // appending date to page
                    //pdf.text(today, (pageWidth / 2) - 10, 0);

                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - height;

                        //creating new page
                        pdf.addPage();

                        // inserting the image in pdf
                        pdf.addImage(image, 'PNG', 0, position, pageWidth, height);

                        // appending date to page
                        //pdf.text(today, (pageWidth / 2) - 10, 0);

                        heightLeft -= pageHeight;
                    }

                    // saving the document
                    pdf.save(TableName.value + '_' + new Date().toISOString().split('T')[0] + '.pdf');

                    // fix table to normal size
                    exportingPDF.value = false;
                    tableElement.style.height = `${1000}px`;

                    //balões de texto
                    let ballonTexts = document.querySelectorAll('.custom-note-buttom');
                    if (ballonTexts) {
                        ballonTexts.forEach(item => {
                            item.classList.remove('export');
                        })
                    }

                    let textDiv = document.querySelectorAll('.custom-note-text');
                    if (textDiv) {
                        textDiv.forEach(item => {
                            item.classList.remove('export');
                        })
                    }

                    store.dispatch(Actions.SET_LOADING_TOGGLE, false);
                });
            }, 100);

            // method using Report API
            //exportData(2);
        };

        const newData = () => {
            emit('newData');
        };

        // Sort table function
        const sort = (item) => {
            if (item.sort) {
                sortBy.value = item.value;
                sortDir.value = !sortDir.value
                searchInput();
            }
        }

        let count = ref(0);
        let editableCurrentValue = ref<any>(null);
        const submitEditRow = (value, prop) => {
            editRowBlur(`${prop}-${value.id}`);
            if (count.value == 0 && value[prop] != editableCurrentValue.value) {
                count.value++

                if (value[prop] != null && value[prop].length > 0) {
                    emit('submit', value);
                    setTimeout(() => {
                        count.value = 0;
                    }, 100);
                }
            }
        }

        const toggleEditRow = (value, prop) => {
            emit('toggleEditRow', { ...value }, prop);
            editableCurrentValue.value = value[prop];
            editableRowsControl.value[`${prop}-${value.id}`] = !editableRowsControl.value[`${prop}-${value.id}`];
            setTimeout(() => {
                if (editableRowsControl.value[`${prop}-${value.id}`]) {
                    let input = document.querySelector('.editable-tr input') as HTMLInputElement;
                    input?.focus();
                }
            }, 100);
        }

        const editRowBlur = (prop) => {
            setTimeout(() => {
                if (editableRowsControl.value[prop])
                    editableRowsControl.value[prop] = false;
            }, 150);
        }

        // submit function
        const submit = (formEl: formInstance | undefined) => {
            if (!formEl) return
            formEl.validate(valid => {
                if (valid) {
                    enableButton.value = true;
                    emit('submit');
                } else {
                    enableButton.value = false;
                    return false
                }
            });
        };

        const submitFormValidation = () => {
            submit(ruleFormRef.value)
        }

        const execValidate = () => {
            let form = ruleFormRef.value as formInstance;
            form.validate();
        };

        // clear form function
        const clearForm = (ruleform) => {
            let form = ruleFormRef.value as formInstance;
            if (form) {
                // resetFields() limpa os valores; clearValidate() garante que as
                // mensagens de erro também sejam removidas (evita validação "presa"
                // ao reabrir um novo cadastro). Ver docs/REVISAO_FORMULARIOS.md.
                if (form.resetFields) form.resetFields();
                if (form.clearValidate) form.clearValidate();
            }

            // Reabilita o botão Salvar ao fechar por qualquer caminho (X, ESC,
            // Cancelar, sucesso) — sem isso o botão fica travado após um erro.
            enableButton.value = false;

            emit('closeForm');
        };

        // Disparado pelo @open do el-dialog: o el-form já está montado, então
        // limpamos validação e reabilitamos o botão para que toda abertura
        // (novo cadastro OU edição) comece com o formulário num estado limpo,
        // independente de o modelo ter sido substituído por inteiro na tela.
        const onDialogOpen = () => {
            enableButton.value = false;
            nextTick(() => {
                let form = ruleFormRef.value as formInstance;
                if (form && form.clearValidate)
                    form.clearValidate();
            });
        };

        // open Modal
        const openModal = (event: any, edit: boolean = false) => {
            if (!edit)
                newData();

            formVisibility.value = true;
            if (document.querySelector('.el-dialog__body'))
                document.querySelector('.el-dialog__body')!.scrollTop = 0;

            // Set Form values from storage filters
            let values: any = null;
            if (window.localStorage.getItem(`${TableName.value.replace(/ /gi, '_')}-TableFilters`))
                values = JSON.parse(window.localStorage.getItem(`${TableName.value.replace(/ /gi, '_')}-TableFilters`) ?? '') as tableFilter;

            if (values) {
                let item = values.searchData;

                item.filter(lbda => {
                    if (lbda.model)
                        props.ruleForm[lbda.model.key] = lbda.model.value;
                });
            }
        };

        // close Modal
        const closeModal = () => {
            if (document.querySelector('.el-dialog__body'))
                document.querySelector('.el-dialog__body')!.scrollTop = 0;
            formVisibility.value = false;
            enableButton.value = false;
        };

        // Retractive and responsible table
        const target = {
            context: {
                tableId: ''
            },
            id: ''
        };

        // set Inative class table
        const isActiveClass = (item) => {
            return item.ativo != undefined && !item.ativo ? 'inative' : '';
        };

        const tableId = ref('');
        const tableEl = ref(new Proxy(target, {}));

        const resizeObserver = new ResizeObserver(entries => {
            if (entries.length > 0) {
                let pageSize = document.querySelector('body')?.clientWidth;

                if (pageSize && pageSize <= 775)
                    mobile.value = true;
                else
                    mobile.value = false;

                let tableWidth = entries[0].target.clientWidth ?? 0;
                let sum = 0;

                if (props.actions)
                    sum = 75;

                for (var i = 0; i < defaultTableHeader.value.length; i++) {

                    sum += defaultTableHeader.value[i].width;

                    let defaultItem = defaultTableHeader.value[i];

                    if ((sum <= tableWidth || i == 0) && !localTableHeader.value.includes(defaultItem)) {
                        localTableHeader.value.push(defaultItem);
                        let indexOf = localTableHeaderExpand.value.indexOf(defaultItem);
                        if (indexOf > -1)
                            localTableHeaderExpand.value.splice(indexOf, 1);
                    }
                    else if ((sum > tableWidth && i > 0 && defaultItem.canHide) && !localTableHeaderExpand.value.includes(defaultItem)) {
                        localTableHeaderExpand.value.push(defaultItem);
                        let indexOf = localTableHeader.value.indexOf(defaultItem);
                        if (indexOf > -1)
                            localTableHeader.value.splice(indexOf, 1);
                    }
                }
            }
        });

        const teableHeight = new ResizeObserver(entries => {
            if (entries.length > 0 && exportingPDF.value == false) {
                const tableContextID = tableEl?.value?.context?.tableId;
                let table = document.querySelector(`#${tableContextID}`);

                let tableDistance = (table?.getBoundingClientRect().top ?? 0) + 120;
                let bodyHeight = document.querySelector('body')?.clientHeight ?? 0;

                let tableElement = document.querySelector(`#${tableContextID}`) as HTMLElement;

                if (tableElement) {

                    let tableBodyHeight = (tableElement.querySelector('tbody')?.clientHeight ?? 0) + 50;

                    let newTableSize = bodyHeight - tableDistance;

                    if (tableBodyHeight < newTableSize) {
                        tableElement.setAttribute("height", `${tableBodyHeight + 15}`);
                        tableElement.style.height = `${tableBodyHeight + 15}px`;
                    } else {
                        tableElement.setAttribute("height", `${newTableSize + 15}`);
                        tableElement.style.height = `${newTableSize + 15}px`;
                    }
                }
            }
        });

        const propEvents = ref(props.events);

        onUnmounted(() => {
            let el = document.querySelector(`#${tableId.value}`);
            nextTick(() => {
                if (el) resizeObserver.unobserve(el as Element);
            });
        });

        onMounted(() => {
            const tableContextID = tableEl?.value?.context?.tableId;
            tableId.value = tableContextID;

            nextTick(() => {
                let el = document.querySelector(`#${tableContextID}`);
                resizeObserver.observe(el as Element);

                let body = document.querySelector('body');
                teableHeight.observe(body as Element);

                let tablebody = document.querySelector('tbody');
                teableHeight.observe(tablebody as Element);
            });

            // tabel events
            if (propEvents.value) {
                propEvents.value.ClearForm.on(clearForm);
                propEvents.value.OpenModal.on(openModal);
                propEvents.value.CloseModal.on(closeModal);
                propEvents.value.UpdateGrid.on(searchInput);
            }
        });

        const createInstance = (item) => {
            return JSON.parse(JSON.stringify(item));
        };

        const getColumnValue = (path, row) => {
            path = path.split('.');

            path.map(x => {
                row = row ? row[x] : '';
            });

            return row;
        };

        // Eventos botões de ação
        const editRow = (item) => {
            emit('editItem', createInstance(item));
        };

        const deleteRow = (item) => {
            emit('deleteItem', createInstance(item));
        };

        // Permissions setup
        const userData = computed(() => { return store.getters.currentUser as any });
        const userClaims = ref(userData.value.userdata.claims);

        const enableUpdate = ref(props.editButton);
        const enableDelete = ref(props.deleteButton);
        const enableInsert = ref(!props.readDataOnly);

        if (props.tableClaim.length > 0) {
            enableUpdate.value = userClaims.value.some((item: any) => item.nome == props.tableClaim && item.update);
            enableDelete.value = userClaims.value.some((item: any) => item.nome == props.tableClaim && item.delete);

            if (!props.readDataOnly)
                enableInsert.value = userClaims.value.some((item: any) => item.nome == props.tableClaim && item.insert);
        }

        const enableSaveButton = () => {
            enableButton.value = false;
        }

        const updateGrid = () => {
            searchInput();
        }

        const setDates = (_startDate: string, _endDate: string) => {
            if (_startDate)
                startDate.value = _startDate;

            if (_endDate)
                finishDate.value = _endDate;

            searchInput()
        }


        // Return Events and variables
        return {
            typingTimer,
            RandomModalId,
            formVisibility,

            mobile,
            open,
            openFilters,

            complexSearchExec,
            complexSearchColumns,
            enableButton,
            enableSaveButton,
            removeComplexTag,
            currentColumnSearch,
            searchData,
            searchTags,
            search,

            minDate,
            maxDate,
            startDate,
            finishDate,
            getColumnValue,

            sortBy,
            sortDir,
            localPage,
            localPageSize,
            localTotalCount,

            tableEl,
            tableId,

            dataTableEmptyText,
            localTableData,
            localTableHeader,
            localTableHeaderExpand,
            defaultTableHeader,

            isActiveClass,

            getTableData,
            exportData,

            columnSearchChange,
            clearFilters,
            searchInput,
            delaySearchInput,
            exportExcelMethod,
            exportPDFMethod,
            newData,
            sort,

            submit,
            ruleFormRef,
            clearForm,
            onDialogOpen,
            submitFormValidation,

            openModal,
            closeModal,

            ReportModel,
            createInstance,

            editRow,
            deleteRow,

            enableUpdate,
            enableDelete,
            enableInsert,

            // testes
            editableRowsControl,
            toggleEditRow,
            submitEditRow,
            editRowBlur,
            execValidate,
            updateGrid,
            setDates
        };
    },
};

</script>

<style>
@import "../../assets/less/custom-table/custom-table.css";
</style>